import {
  hideLoaderDomUtil,
  showLoaderDomUtil
} from 'client/utils/dom'
import { getHeadersAndEndpointApiUtil } from 'modules/api/utils'
import fetchNetworkUtil from 'modules/training/modules/network/utils/fetch'
import { setTrainingJwtCookieUtil } from 'modules/api/services/get/utils/setTrainingJwtCookie/index.js'

async function getApiService (endpointParam, options) {
  const {
    headers,
    endpoint
  } = getHeadersAndEndpointApiUtil(endpointParam, options)

  if (BROWSER) {
    showLoaderDomUtil()
  }
  const response = await fetchNetworkUtil(endpoint, {
    credentials: 'include',
    headers,
    method: 'GET'
  })
  const json = await response.json()

  if (SERVER) {
    setTrainingJwtCookieUtil({
      response,
      options
    })
  }

  if (response.ok) {
    if (BROWSER) {
      hideLoaderDomUtil()
    }
    return json
  }
  if (BROWSER) {
    hideLoaderDomUtil()
  }
  throw json
}

export default getApiService
